import * as $ from "jquery";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, Inject } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { AppRoutes } from "./app.routing";
import { AppComponent } from "./app.component";
import { EditorModule } from '@tinymce/tinymce-angular';
import { FlexLayoutModule } from "@angular/flex-layout";
import { FullComponent } from "./layouts/full/full.component";
import { AppBlankComponent } from "./layouts/blank/blank.component";
import { AppHeaderComponent } from "./layouts/full/header/header.component";
import { AppSidebarComponent } from "./layouts/full/sidebar/sidebar.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DemoMaterialModule } from "./demo-material-module";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { NgxCurrencyModule } from "ngx-currency";
import { NgxMaskModule } from "ngx-mask";
import { PinchZoomModule } from "ngx-pinch-zoom";

import { SharedModule } from "./shared/shared.module";
import { SpinnerComponent } from "./shared/spinner.component";
import { ConfirmationDialog } from "./shared/dialog/confirmation-dialog/confirmation-dialog";

import { FinancierLimitDialog } from "./shared/dialog/financier-limit-dialog/financier-limit-dialog";
import { BottomSheet } from "./shared/dialog/bottomSheet/bottom-sheet";
import { SharedService } from "./shared/shared.services";
import { SnackBarService } from "./shared/service/snack.bar.service";
import { SubheaderComponent } from "./layouts/full/subheader/subheader.component";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { ReactiveFormsModule } from "@angular/forms";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { ListDialog } from "./shared/dialog/list-dialog/list-dialog";

import { NavigationService } from "./shared/service/navigation.service";
import { HeaderService } from "./shared/service/header.service";
import { FooterComponent } from "./layouts/full/footer/footer.component";
import { AuthGuard } from "./authentication/guard/auth.guard";
import { AuthService } from "./authentication/oidc/auth.service";
import { CookieService } from "./shared/service/cookie.service";
import { UpdateUnit } from "./shared/dialog/update-unit/update-unit";
import { UserService } from "./shared/service/user.service";
import { PhotoZoomComponent } from "./shared/component/photo-zoom/photo-zoom.component";
import { PhotoZoomService } from "./shared/service/photo-zoom.service";
import { GraphQLModule } from "./graphql.module";
import { NgxMatIntlTelInputModule } from "ngx-mat-intl-tel-input";
import { AssignDiscountDialog } from "./shared/dialog/assign-discount-dialog/assign-discount-dialog";
import { AccessDomainDialog } from "./shared/dialog/access-domain-dialog/access-domain";
import { AddContactDialog } from "./shared/dialog/add-contact-dialog/add-contact-dialog";
import { AddCampaignDialog } from "./shared/dialog/add-campaign-dialog/add-campaign-dialog";
import { AssignEFDialog } from "./shared/dialog/assgin-ef-dialog/assgin-ef-dialog";
import { SettingItemDialog } from "./shared/dialog/setting-item-dialog/setting-item-dialog";
import { AgmCoreModule } from "@agm/core";
import { UOMItemDialog } from "./shared/dialog/uom-item-dialog/uom-item-dialog";
import { TaxCodeDialog } from "./shared/dialog/tax-code-dialog/tax-code-dialog";
import { ProjectService } from "./shared/service/project.service";
import { SwitchProjectModule } from "./shared/component/switch-project/switch-project.module";
import { SwitchProjectDialog } from "./shared/component/switch-project/dialog/switch-project-dialog";
import { SwitchAccountDialog } from "./shared/dialog/switch-account-dialog/switch-account-dialog";

import { HttpRequestInterceptor } from "./shared/http/interceptor/http.interceptor.service";
import { TeamDialog } from "./shared/dialog/team-dialog/team-dialog";
import { AssignSolicitorDialog } from "./shared/dialog/assgin-solicitor-dialog/assgin-solicitor-dialog";
import { UnitStatusDialog } from "./shared/dialog/unit-status-dialog/unit-status-dialog";
import { UnitDetailsDialog } from "./shared/dialog/unit-details-dialog/unit-details-dialog";
import { BreadcrumbComponent } from "./layouts/full/breadcrumb/breadcrumb.component";
import { UploadUnitActionDialog } from "./shared/dialog/upload-unit-action/upload-unit-action";
import { UnblockUserDialog } from "./shared/dialog/unblock-user-dialog/unblock-user.dialog";
import {
  ImageCompressOption,
  ImageCompressService,
  IMAGE_COMPRESS_CONFIG
} from "./shared/service/image-compress.service";
import { UploadSalesDocDialog } from "./shared/dialog/upload-sales-doc-dialog/upload-sales-doc-dialog";
import { SalesDocumentDialog } from "./shared/dialog/sales-documents-dialog/sales-documents-dialog";
import { LetterDialogComponent } from "./shared/dialog/letter-dialog/letter-dialog.component";
import { EmailContactDialog } from "./shared/dialog/email-contact-dialog/email-contact-dialog";
import { WhatsappContactDialog } from "./shared/dialog/whatsapp-contact-dialog/whatsapp-contact-dialog";
import { LeadContactDialog } from "./shared/dialog/lead-contact-dialog/lead-contact-dialog";
import { CustomPipeModule } from "./shared/pipe/pipe.module";
import { ReportPrintDialog } from './shared/dialog/report-print-dialog/report-print';
import { CustomDirectiveModule } from './shared/directive/directive.module';
import { PropspectDialog } from './shared/dialog/prospect-dialog/prospect-dialog';
import { PurchaserDialog } from './shared/dialog/purchaser-dialog/purchaser-dialog';
import { ElaunchViewDialog } from './shared/dialog/elaunch-view-dialog/elaunch-view-dialog';
import { UpdateApiDialog } from "./shared/dialog/update-api-dialog/update-api-dialog";
import { LeadAutomationDialog } from "./shared/dialog/lead-automation-dialog/lead-automation-dialog";
import { MatGridListModule } from "@angular/material/grid-list";
import { UserProjectDialog } from "./shared/dialog/user-project-dialog/user-project-dialog";
import { AddCloseDateDialog } from './shared/dialog/add-close-date-dialog/add-close-date-dialog'
import { CarParkDialog } from './shared/dialog/car-park-dialog/car-park-dialog';
import { NupReasonDialog } from "./shared/dialog/nup-reason-dialog/nup-reason-dialog";

export const customCurrencyMaskConfig = {
  align: "left",
  allowNegative: false,
  allowZero: false,
  decimal: ".",
  precision: 2,
  prefix: "",
  suffix: "",
  thousands: ",",
  nullable: false,
};

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
};

const DEFAULT_IMAGE_COMPRESS_CONFIG: ImageCompressOption = {
  convertSize: 25000000,
  quality: 0.8
};

export const MY_FORMATS = {
  parse: {
    dateInput: environment.InputDateFormat,
  },
  display: {
    dateInput: environment.InputDateFormat,
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};



@NgModule({
  entryComponents: [
    ConfirmationDialog,
    SwitchAccountDialog,
    AssignDiscountDialog,
    AccessDomainDialog,
    PhotoZoomComponent,
    UpdateUnit,
    AddContactDialog,
    AddCampaignDialog,
    SettingItemDialog,
    NupReasonDialog,
    SwitchProjectDialog,
    AssignEFDialog,
    BottomSheet,
    UOMItemDialog,
    TaxCodeDialog,
    ListDialog,
    TeamDialog,
    UnblockUserDialog,
    AssignSolicitorDialog,
    UnitStatusDialog,
    UnitDetailsDialog,
    UploadUnitActionDialog,
    FinancierLimitDialog,
    UploadSalesDocDialog,
    ElaunchViewDialog,
    SalesDocumentDialog,
    LetterDialogComponent,
    EmailContactDialog,
    WhatsappContactDialog,
    LeadContactDialog,
    ReportPrintDialog,
    PropspectDialog,
    PurchaserDialog,
    UpdateApiDialog,
    LeadAutomationDialog,
    UserProjectDialog,
    AddCloseDateDialog,
    CarParkDialog
  ],
  declarations: [
    AppComponent,
    FullComponent,
    AppHeaderComponent,
    SpinnerComponent,
    AppBlankComponent,
    AppSidebarComponent,
    ConfirmationDialog,
    AssignDiscountDialog,
    SwitchProjectDialog,
    SwitchAccountDialog,
    AccessDomainDialog,
    NupReasonDialog,
    AddContactDialog,
    AddCampaignDialog,
    UOMItemDialog,
    SettingItemDialog,
    UploadUnitActionDialog,
    AssignEFDialog,
    UpdateUnit,
    BottomSheet,
    ListDialog,
    TeamDialog,
    UnblockUserDialog,
    SubheaderComponent,
    BreadcrumbComponent,
    FooterComponent,
    TaxCodeDialog,
    PhotoZoomComponent,
    UnitDetailsDialog,
    AssignSolicitorDialog,
    UnitStatusDialog,
    FinancierLimitDialog,
    UploadSalesDocDialog,
    SalesDocumentDialog,
    LetterDialogComponent,
    EmailContactDialog,
    WhatsappContactDialog,
    LeadContactDialog,
    ReportPrintDialog,
    PropspectDialog,
    UpdateApiDialog,
    LeadAutomationDialog,
    UserProjectDialog,
    AddCloseDateDialog,
    CarParkDialog
  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    DemoMaterialModule,
    FlexLayoutModule,
    MatBottomSheetModule,
    EditorModule,
    HttpClientModule,
    PerfectScrollbarModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule.forRoot(AppRoutes, { onSameUrlNavigation: "reload" }),
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    NgxMaskModule.forRoot(),
    NgxMatIntlTelInputModule,
    SwitchProjectModule,
    PinchZoomModule,
    GraphQLModule,
    AgmCoreModule.forRoot({
      apiKey: environment.GoogleApiKey,
      libraries: ["places"],
    }),
    CustomPipeModule,
    CustomDirectiveModule,
    MatGridListModule
  ],

  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    PhotoZoomService,
    SharedService,
    SnackBarService,
    AuthGuard,
    AuthService,
    NavigationService,
    ProjectService,
    HeaderService,
    CookieService,
    UserService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    ImageCompressService,
    {
      provide: IMAGE_COMPRESS_CONFIG,
      useValue: DEFAULT_IMAGE_COMPRESS_CONFIG,
    },
  ],

  bootstrap: [AppComponent],
})
export class AppModule { }
